import { Pipe, PipeTransform } from '@angular/core';
import { Langs, LangService } from '@shared/services/lang.service';

@Pipe({
  name: 'datepickerFormat',
})
export class DatepickerFormat implements PipeTransform {
  constructor(private langService: LangService) {}

  transform(value: any): string {
    switch (this.langService.lang) {
      case Langs.ru:
        return 'дд.мм.гггг';
      case Langs.en:
        return 'M.DD.YYYY';
      default:
        return 'дд.мм.гггг';
    }
  }
}
